
import assignmentApi from '@/api/assignmentAPI'
import postApi from '@/api/postAPI'

export const assignmentStore = {
  // This makes your getters, mutations, and actions accessed by, eg: 'userStore/{name}' instead of mounting getters, mutations, and actions to the root namespace.
  namespaced: true,

  state: {
      all_student_assignments : [], // for widget
      assignments : {},
      assignment_obj : {},
      past_user_feedback : {},
      turnin_obj : {},
      total_turnin_data : {},
      user_turnins : {}
  },


  getters: {

      // getLoggedInUserInfo: state => {
      //   return state.user
      // }
  },


    actions : {

        clearAssignmentStore({ commit, state }, { group_id }) {
            commit('CLEAR_STORE', {
                group_id : group_id
            })
            return 1
        },

        /**
            Function for creating a new assignment
         */
        async correctAssignmentDate({ commit, state }, { assignment_id, date }) {

            const response = await assignmentApi.correctAssignmentDate({
                assignment_id : assignment_id,
                date : date
            })

            return response.data
        },

        async correctAssignmentPlanDate({ commit, state }, { assignment_id, user_id, date, calculate_after=0 }) {

            const response = await assignmentApi.correctAssignmentPlanDate({
                assignment_id : assignment_id,
                user_id : user_id,
                date : date,
                calculate_after : calculate_after
            })
          if (response.status === 200 && response.data) {
            commit('CHANGE_USER_DATE', {
                assignment_id : assignment_id,
                user_id: user_id,
                date: response.data.date
            })
          }

            return response.data
        },

        // Admin-only: close/open late submission for a single student.
        async toggleLateBlock({ commit }, { assignment_id, user_id, block }) {
            const response = block
                ? await assignmentApi.blockLateSubmission({ assignment_id, user_id })
                : await assignmentApi.unblockLateSubmission({ assignment_id, user_id })

            if (response.status === 200) {
                commit('SET_USER_LATE_BLOCK', {
                    assignment_id,
                    user_id,
                    late_blocked: block ? 1 : 0
                })
            }

            return response.data
        },

        async createAssignment({ commit, state }, { group_id, assignment_data }) {

            const response = await assignmentApi.createAssignment({ assignment_data })

            commit('CREATE_ASSIGNMENT', {
                group_id : group_id,
                assignment_data : response.data
            })

            return response
        },

        /**
            Function for creating a new feedback to an assignment
         */
        async createAssignmentFeedback({ commit, state }, { post_id, assignment_id, post_data }) {
            if(!post_data) return
            const response = await postApi.createNewPost(post_data)

            let feedback_post_data = response.data
            commit('SAVE_ASSIGNMENT_POST_FEEDBACK', {
                post_id : post_id,
                assignment_id : assignment_id,
                feedback_post_data : feedback_post_data,
                reject_assignment : !!post_data.reject_assignment
            })

            if (!!post_data.reject_assignment) {
                commit('SET_FEEDBACK_RELEASED', {
                    assignment_id : assignment_id,
                    feedback_post_id : feedback_post_data.post_id,
                    time : new Date().getTime()
                })
            }

            return response

        },

        async createExternalHandin({ commit, state }, { feedback_data }) {

            return await assignmentApi.createExternalHandin({
                feedback_data : feedback_data
            })

        },

        /**
            Function for saving an assignment
         */
        async editAssignment({ commit, state }, { assignment_id, group_id, assignment_data }) {

            const response = await assignmentApi.editAssignment({
                assignment_id : assignment_id,
                assignment_data : assignment_data
            })

            commit('EDIT_ASSIGNMENT', {
                assignment_id : assignment_id,
                group_id : group_id,
                assignment_data : response.data
            })

            return response

        },

        async editAssignmentAnswer(vx, data) {
          const { commit, rootState } = vx
          const { user_id, post_id, assignment_id, assignment_data } = data

          // Check if user is a mock student
          const isMockStudent = rootState.groupStore.isMockStudent || false

          await assignmentApi.editAssignmentAnswer({
            post_id,
            assignment_data,
          }, isMockStudent)

          const response = await assignmentApi.getAssignmentAnswer({
            assignment_id,
            user_id,
          }, isMockStudent)

          let assignment_user_posts = response.data

          if (isMockStudent) {
            // Use mock data
            assignment_user_posts = [
              {
                ...assignment_data,
                firstname: 'Student',
                lastname: 'Tester',
                edit_date: Date.now() / 1000,
                post_id,
                user_id,
              },
            ]
          }

          if (!!assignment_user_posts.length) {
            commit('SET_USER_ASSIGNMENT_POSTS', {
              user_id,
              assignment_id,
              assignment_user_posts,
            })
          }

          return response
        },

        /**
        * Function for fetching assignments for group
        */
        async fetchAllGroupAssignments({ commit, state }, { group_id, bypass_cache=false }) {

            if (!bypass_cache && state.assignments[group_id] && state.assignments[group_id].length) {
                return state.assignments[group_id]
            } else {

                const response = await assignmentApi.fetchAllGroupAssignments(group_id)

                commit('SET_GROUP_ASSIGNMENTS', {
                    group_id : group_id,
                    assignments : response.data
                })

                return response.data
            }

        },

        /**
         * Get student assignment plan data for widget on frontpage
         */
        async getAllUserAssignments({ commit, state }) {

            const response = await assignmentApi.getAllUserAssignments()
            commit('SET_ALL_USER_ASSIGNMENTS', {
                data : response.data
            })

            return response
        },

        async getAllPastFeedbackFromUserAssignments({ commit, state }, { group_id, user_id }) {

            // use cache if fetched
            if (state.assignments[group_id] && state.assignments[group_id][user_id]) {
                return state.assignments[group_id][user_id]
            }

            const response = await assignmentApi.getAllPastFeedbackFromUserAssignments({ group_id, user_id })

            commit('SET_PAST_USER_FEEDBACK', {
                group_id : group_id,
                user_id : user_id,
                data : response.data
            })

            return response
        },

        async getAssignmentAnswer({ commit, state }, { user_id, assignment_id }) {

            const response = await assignmentApi.getAssignmentAnswer({ user_id, assignment_id})
          const assignment_user_posts = response.data
            if (assignment_user_posts && assignment_user_posts.length) {
                commit('SET_USER_ASSIGNMENT_POSTS', {
                    user_id : user_id,
                    assignment_id : assignment_id,
                    assignment_user_posts : assignment_user_posts
                })
            }

            return response
        },

        /**
         * Function for getting data for a single assignment element
         */
        async getAssignmentData({ commit, state }, { assignment_id, group_id }) {

            const response = await assignmentApi.getAssignmentData({
                assignment_id : assignment_id
            })

            commit('EDIT_ASSIGNMENT', {
                assignment_id : assignment_id,
                group_id : group_id,
                assignment_data : response.data
            })

            return response

        },

        async getAssignmentsWithoutFeedback({ commit, state }) {

            const response = await assignmentApi.getAssignmentsWithoutFeedback()

            return response.data

        },

        async getSubmissionsWithoutFeedback({ commit, state }) {

            const response = await assignmentApi.getSubmissionsWithoutFeedback()

            return response.data

        },

        async pullAllTurninData({ commit, state }, { assignment_id, group_id }) {

            const response = await assignmentApi.pullAllTurninData({ assignment_id, group_id })

            if (response.data) {
                commit('SAVE_ALL_ASSIGNMENT_TURN_IN_DATA', {
                    assignment_id : assignment_id,
                    assignment_turnin_data : response.data
                })
            }

            return response
        },

        async registerFeedbackSeen({ commit, state }, { feedback_id }) {

            return await assignmentApi.registerFeedbackSeen({
                feedback_id : feedback_id
            })

        },


        async removeAssignment({ commit, state }, { assignment_id, group_id }) {

            const response = assignmentApi.removeAssignment(assignment_id)

            commit('REMOVE_ASSIGNMENT', { assignment_id, group_id })

            return await response
        },

        /**
         * @desc Remove assigment answer
         * @param {Object} vx - Vuex specific functions
         * @param {Object} data - Assignment data
         * @param {number} data.user_id
         * @param {number} data.group_id
         * @param {number} data.assignment_id
         * @param {number} data.post_id
         * @return {Promise} response
         */
        async removeAssignmentAnswer(vx, data) {
          const { commit, rootState } = vx
          const { user_id, group_id, assignment_id, post_id } = data

          // Check if user is a mock student
          const isMockStudent = rootState.groupStore.isMockStudent || false

          // Delete assignment answer
          const response = await assignmentApi.removeAssignmentAnswer({
            post_id,
          }, isMockStudent)

          // Remove assignment answer from state
          commit('REMOVE_USER_ASSIGNMENT_ANSWER', {
            post_id,
            group_id,
            assignment_id,
          })

          return response
        },

        async removeAssignmentFeedback({ commit, state }, { post_id , feedback_post_id, assignment_id }) {

            const response = postApi.removePost(feedback_post_id)

            const response2 = assignmentApi.removeFeedback(feedback_post_id)

            commit('REMOVE_ASSIGNMENT_FEEDBACK', { post_id, assignment_id })

            return await Promise.all([
                response,
                response2
            ])

        },

        /**
            Persist an already-uploaded file onto an EXISTING feedback post
            and reflect it in the turn-in list.

            Without the server call the attachment lived only in component
            state until the next full feedback save — which for a second
            DirectEdit document never happened, so the correction was lost
            on navigation while the UI claimed it was attached.
         */
        async attachFeedbackAttachment({ commit }, { post_id, assignment_id, feedback_post_id, attachment }) {
            const media_id = parseInt(attachment && attachment.media_id) || 0
            if (!feedback_post_id || !media_id) {
                return null
            }

            const response = await postApi.attachMediaToPost(feedback_post_id, [media_id])

            commit('ADD_FEEDBACK_ATTACHMENT', { post_id, assignment_id, attachment })

            return response
        },

        /*
            Function for removing an attachment from a feedback post
         */
        async removeFeedbackAttachment({ commit }, { post_id, assignment_id, feedback_post_id, media_id }) {
            // Detach server-side first: the post-save path only ever ADDS
            // attachments, so a local-only removal came back on reload.
            // Skipped when the attachment is still unsaved (no feedback
            // post yet) — there is nothing to detach.
            if (feedback_post_id && media_id) {
                await postApi.detachMediaFromPost(feedback_post_id, media_id)
            }

            commit('REMOVE_FEEDBACK_ATTACHMENT', { post_id, assignment_id, media_id })
        },

        /*
           Function for creating a new feedback to an assignment
        */
        async saveAssignmentFeedback({ commit, state }, { post_id, feedback_post_id, assignment_id, post_data }) {

            const response = await postApi.editPost(feedback_post_id, post_data)

          let feedback_post_data = response.data
          console.log(feedback_post_data)
            commit('SAVE_ASSIGNMENT_POST_FEEDBACK', {
                post_id : post_id,
                assignment_id : assignment_id,
                feedback_post_data : feedback_post_data,
                reject_assignment : !!post_data.reject_assignment
            })

            if (!!post_data.reject_assignment) {
                commit('SET_FEEDBACK_RELEASED', {
                    assignment_id : assignment_id,
                    feedback_post_id : feedback_post_id,
                    time : new Date().getTime()
                })
            }

            return response

        },

        /*
            Function for saving the text in feedback when direct editing a document #hack
         */
        saveAssignmentFeedbackText({ commit, state }, { post_id, assignment_id, post_text }) {
            commit('SAVE_ASSIGNMENT_POST_FEEDBACK_TEXT', { post_id, assignment_id, post_text } )
        },

        /*
          Function for creating a new feedback to an assignment
       */
        async sendUnReleasedTurninFeedback({ commit, state }, { assignment_id, feedback_post_id, user_ids }) {

            const response = await assignmentApi.sendUnReleasedTurninFeedback({
                assignment_id : assignment_id,
                feedback_post_id : feedback_post_id,
                user_ids
            })

            const time = response.data
            commit('SET_FEEDBACK_RELEASED', { assignment_id, feedback_post_id, time })

            return response
        },

        /**
         * @desc Submit assignment answer
         * @param {Object} vx - Vuex specific functions
         * @param {Object} data - Assignment data
         * @param {number} data.user_id
         * @param {number} data.group_id
         * @param {number} data.assignment_id
         * @param {Object} data.assignment_data
         * @return {Promise} response
         */
        async submitAssignmentAnswer(vx, data) {
          const { commit, rootState  } = vx
          const { user_id, group_id, assignment_id, assignment_data } = data

          // Check if user is a mock student
          const isMockStudent = rootState.groupStore.isMockStudent || false

          // Submit assignment
          await assignmentApi.submitAssignmentAnswer({
            assignment_data,
          }, isMockStudent)

          // Get assignment answer
          const response = await assignmentApi.getAssignmentAnswer({
            assignment_id,
            user_id,
          }, isMockStudent)

          let assignment_user_posts = response.data

          if (isMockStudent) {
            const currentDate = Date.now()
            // Use mock data
            assignment_user_posts = [
              {
                ...assignment_data,
                firstname: 'Student',
                lastname: 'Tester',
                post_id: currentDate,
                post_date: currentDate / 1000,
                mock_identifier: true,
                user_id,
              },
            ]
          }

          // Update assignment answer state
          if (!!assignment_user_posts.length) {
            commit('SET_USER_ASSIGNMENT_POSTS', {
              user_id,
              group_id,
              assignment_id,
              assignment_user_posts,
            })
          }

          return response
        },

    },


  mutations: {

      CHANGE_USER_DATE: (state, { assignment_id, user_id, date }) => {
          if(!state.total_turnin_data[assignment_id]) return 0
          const objIndex = state.total_turnin_data[assignment_id].findIndex(item => item.user_id === user_id)
            if (objIndex !== -1) {
              const obj = state.total_turnin_data[assignment_id][objIndex]
              obj.user_due_date = `${date}`
              state.total_turnin_data[assignment_id].splice(objIndex, 1, obj)
            }
        },

        CLEAR_STORE: (state, { group_id }) => {
            state.assignments[group_id] = []
        },

        CREATE_ASSIGNMENT: (state, { group_id, assignment_data }) => {
            if (!state.assignments[group_id]) {
                state.assignments[group_id] = []
            }
            state.assignments[group_id].push(assignment_data)
            state.assignment_obj[assignment_data['assignment_id']] = assignment_data
        },

        EDIT_ASSIGNMENT: (state, { assignment_id, group_id, assignment_data }) => {

            // locate assignment
            if (state.assignments[group_id]) {
                state.assignments[group_id].map((assignment, index) => {
                    if (parseInt(assignment['assignment_id']) === parseInt(assignment_id)) {
                        // merge data to keep course title
                        const new_data = Object.assign(assignment, assignment_data)
                        state.assignments[group_id][index] = new_data
                    }
                })
            }

            state.assignment_obj[assignment_id] = assignment_data

        },

        REMOVE_ASSIGNMENT: (state, { assignment_id, group_id }) => {

            if (state.assignments[group_id]) {
                state.assignments[group_id].map( (assignment, assignment_index) => {
                    if (parseInt(assignment['assignment_id']) === parseInt(assignment_id)) {
                        state.assignments[group_id].splice(assignment_index, 1)
                    }
                })
            }

            delete state.assignment_obj[assignment_id]

        },


        REMOVE_ASSIGNMENT_FEEDBACK: (state, { post_id, assignment_id }) => {

            if (state.total_turnin_data[assignment_id]) {
                state.total_turnin_data[assignment_id].map((post, post_index) => {
                    if (parseInt(post['post_id']) === parseInt(post_id)) {

                        state.total_turnin_data[assignment_id][post_index].feedback = {}
                        state.total_turnin_data[assignment_id][post_index].feedback_post_id = null
                        state.total_turnin_data[assignment_id][post_index].feedback_release_date = null

                        // if delete feedback - make sure to undo rejection
                        state.total_turnin_data[assignment_id][post_index].post_status = 'public'
                    }
                })
            }

            if (state.user_turnins[assignment_id]) {
                state.user_turnins[assignment_id].map((post, post_index) => {
                    if (parseInt(post['post_id']) === parseInt(post_id)) {
                        state.user_turnins[assignment_id][post_index].feedback = {}
                        state.user_turnins[assignment_id][post_index].feedback_post_id = null
                        state.user_turnins[assignment_id][post_index].feedback_release_date = null

                        // if delete feedback - make sure to undo rejection
                        state.user_turnins[assignment_id][post_index].post_status = 'public'
                    }
                })
            }

        },

        ADD_FEEDBACK_ATTACHMENT: (state, { post_id, assignment_id, attachment }) => {

            if (!attachment || !state.user_turnins[assignment_id]) {
                return
            }

            state.user_turnins[assignment_id].map( (post, post_index) => {
                if (parseInt(post['post_id']) !== parseInt(post_id)) {
                    return
                }

                const feedback = state.user_turnins[assignment_id][post_index]['feedback']
                if (!feedback) {
                    return
                }

                if (!feedback['attachments']) {
                    feedback['attachments'] = []
                }

                // The attach endpoint is idempotent, so a retry must not
                // double the row in the list the teacher is looking at.
                const exists = feedback['attachments'].some(
                    att => parseInt(att['media_id']) === parseInt(attachment['media_id'])
                )
                if (!exists) {
                    feedback['attachments'].push(attachment)
                }
            })

        },

        REMOVE_FEEDBACK_ATTACHMENT: (state, { post_id, assignment_id, media_id }) => {

            if (state.user_turnins[assignment_id]) {
                state.user_turnins[assignment_id].map( (post, post_index) => {
                    if (parseInt(post['post_id']) === parseInt(post_id)) {
                        let attachments = state.user_turnins[assignment_id][post_index]['feedback']['attachments']
                        attachments.map( (att, att_index) => {
                            if (parseInt(att['media_id']) === parseInt(media_id)) {
                                state.user_turnins[assignment_id][post_index]['feedback']['attachments'].splice(att_index, 1)
                            }
                        })
                    }
                })
            }

        },

        REMOVE_USER_ASSIGNMENT_ANSWER: (state, { post_id, group_id, assignment_id }) => {

            if (state.user_turnins[assignment_id]) {
                state.user_turnins[assignment_id].map((post, post_index) => {
                    if (parseInt(post['post_id']) === parseInt(post_id)) {
                        state.user_turnins[assignment_id].splice(post_index, 1)
                    }
                })
            }

            // Remove from total_turnin_data (teacher's turnin overview)
            if (state.total_turnin_data[assignment_id]) {
                const idx = state.total_turnin_data[assignment_id].findIndex(
                    p => parseInt(p.post_id) === parseInt(post_id)
                )
                if (idx !== -1) {
                    state.total_turnin_data[assignment_id].splice(idx, 1)
                }
            }

            // update overview
            if (state.assignments[group_id]) {
                state.assignments[group_id].map( (assignment, index) => {
                    if (parseInt(assignment.assignment_id) === parseInt(assignment_id)) {
                        state.assignments[group_id][index].post_id = 0
                        state.assignments[group_id][index].tag_id = 0
                    }
                })
            }

        },


        SAVE_ALL_ASSIGNMENT_TURN_IN_DATA: (state, { assignment_id, assignment_turnin_data }) => {

            state.total_turnin_data[assignment_id] = assignment_turnin_data

        },

        SET_USER_LATE_BLOCK: (state, { assignment_id, user_id, late_blocked }) => {
            const turnins = state.total_turnin_data[assignment_id]
            if (!turnins) return
            const idx = turnins.findIndex(post => parseInt(post.user_id) === parseInt(user_id))
            if (idx !== -1) {
                state.total_turnin_data[assignment_id][idx].late_blocked = late_blocked
            }
        },

        SAVE_ASSIGNMENT_POST_FEEDBACK: (state, { post_id, assignment_id, feedback_post_data, reject_assignment = false }) => {

            let turnins = state.total_turnin_data[assignment_id]
            for (let post of turnins) {
                if (parseInt(post['post_id']) === parseInt(post_id)) {
                    let post_index = state.total_turnin_data[assignment_id].indexOf(post)
                    state.total_turnin_data[assignment_id][post_index].feedback = feedback_post_data
                    state.total_turnin_data[assignment_id][post_index].feedback_post_id = feedback_post_data.post_id
                    if (!post.feedback_release_date && parseInt(!post.feedback_release_date)) {
                        state.total_turnin_data[assignment_id][post_index].feedback_release_date = 0
                    }

                    let post_status = reject_assignment ? 'rejected' : 'public'
                    state.total_turnin_data[assignment_id][post_index].post_status = post_status

                    break
                }
            }

            state.user_turnins[assignment_id].map( (post, post_index) => {
                if (parseInt(post['post_id']) === parseInt(post_id)) {
                    state.user_turnins[assignment_id][post_index].feedback = feedback_post_data
                    state.user_turnins[assignment_id][post_index].feedback_post_id = feedback_post_data.post_id
                    if (!post.feedback_release_date && parseInt(!post.feedback_release_date)) {
                        state.user_turnins[assignment_id][post_index].feedback_release_date = 0
                    }

                    let post_status = reject_assignment ? 'rejected' : 'public'
                    state.user_turnins[assignment_id][post_index].post_status = post_status
                }
            })

        },

        SAVE_ASSIGNMENT_POST_FEEDBACK_TEXT: (state, { post_id, assignment_id, post_text }) => {

            if (state.user_turnins[assignment_id]) {
                if (state.user_turnins[assignment_id]) {
                    state.user_turnins[assignment_id].map((post, post_index) => {
                        if (parseInt(post['post_id']) === parseInt(post_id)) {
                            state.user_turnins[assignment_id][post_index]['feedback'].post_text = post_text
                        }
                    })
                }
            }

        },

        SET_ALL_USER_ASSIGNMENTS: (state, { data }) => {
            state.all_student_assignments = data
        },

        SET_FEEDBACK_RELEASED: (state, { assignment_id, feedback_post_id, time }) => {

            if (state.total_turnin_data[assignment_id]) {
                state.total_turnin_data[assignment_id].map((post, post_index) => {
                    if (post && (parseInt(post.feedback_post_id) === parseInt(feedback_post_id))) {
                        state.total_turnin_data[assignment_id][post_index].feedback_release_date = time
                    }
                })
            }

            if (state.user_turnins[assignment_id]) {
                state.user_turnins[assignment_id].map( (post, post_index) => {
                    if (post && post['feedback'] && post['feedback'].post_id && (parseInt(post['feedback']['post_id']) === parseInt(feedback_post_id))) {
                        state.user_turnins[assignment_id][post_index].feedback_release_date = time
                    }
                })
            }

        },

        SET_GROUP_ASSIGNMENTS: (state, { group_id, assignments }) => {
            // set all assignments
            state.assignments[group_id] = assignments
            //create object for fast retrieval
            assignments.map(assignment => {
                state.assignment_obj[assignment['assignment_id']] = assignment
            })
        },

        SET_PAST_USER_FEEDBACK: (state, { user_id, group_id, data }) => {
            if (!state.past_user_feedback[user_id]) {
                state.past_user_feedback[user_id] = {}
            }
            state.past_user_feedback[user_id][group_id] = data
        },

        SET_USER_ASSIGNMENT_POSTS: (state, { user_id, group_id, assignment_id, assignment_user_posts }) => {

            // set turnins
          state.user_turnins[assignment_id] = assignment_user_posts

            // update overview
            if (state.assignments[group_id]) {
                state.assignments[group_id].map( (assignment, index) => {
                    if (parseInt(assignment.assignment_id) === parseInt(assignment_id)) {
                        state.assignments[group_id][index].tag_id = user_id
                    }
                })
            }

        }
    }
}
